module.exports = __webpack_public_path__ + "static/media/smaller-script-icon.7504d3a9.svg";